var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgegold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6211_10269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.753 2.99442C41.4826 2.41264 42.5174 2.41265 43.247 2.99442L46.6859 5.73689C47.1927 6.14099 47.8638 6.27448 48.4866 6.09506L52.7133 4.87739C53.6099 4.61907 54.566 5.01511 55.0174 5.83178L57.1451 9.68152C57.4586 10.2488 58.0275 10.6289 58.6716 10.7015L63.0425 11.194C63.9697 11.2985 64.7015 12.0303 64.806 12.9575L65.2985 17.3284C65.3711 17.9725 65.7512 18.5414 66.3185 18.8549L70.1682 20.9826C70.9849 21.434 71.3809 22.3901 71.1226 23.2867L69.9049 27.5134C69.7255 28.1362 69.859 28.8073 70.2631 29.3141L73.0056 32.753C73.5874 33.4826 73.5874 34.5174 73.0056 35.247L70.2631 38.6859C69.859 39.1927 69.7255 39.8638 69.9049 40.4866L71.1226 44.7133C71.3809 45.6099 70.9849 46.566 70.1682 47.0174L66.3185 49.1451C65.7512 49.4586 65.3711 50.0275 65.2985 50.6716L64.806 55.0425C64.7015 55.9697 63.9697 56.7015 63.0425 56.806L58.6716 57.2985C58.0275 57.3711 57.4586 57.7512 57.1451 58.3185L55.0174 62.1682C54.566 62.9849 53.6099 63.3809 52.7133 63.1226L48.4866 61.9049C47.8638 61.7255 47.1927 61.859 46.6859 62.2631L43.247 65.0056C42.5174 65.5874 41.4826 65.5874 40.753 65.0056L37.3141 62.2631C36.8073 61.859 36.1362 61.7255 35.5134 61.9049L31.2867 63.1226C30.3901 63.3809 29.434 62.9849 28.9826 62.1682L26.8549 58.3185C26.5414 57.7512 25.9725 57.3711 25.3284 57.2985L20.9575 56.806C20.0303 56.7015 19.2985 55.9697 19.194 55.0425L18.7015 50.6716C18.6289 50.0275 18.2488 49.4586 17.6815 49.1451L13.8318 47.0174C13.0151 46.566 12.6191 45.6099 12.8774 44.7133L14.0951 40.4866C14.2745 39.8638 14.141 39.1927 13.7369 38.6859L10.9944 35.247C10.4126 34.5174 10.4126 33.4826 10.9944 32.753L13.7369 29.3141C14.141 28.8073 14.2745 28.1362 14.0951 27.5134L12.8774 23.2867C12.6191 22.3901 13.0151 21.434 13.8318 20.9826L17.6815 18.8549C18.2488 18.5414 18.6289 17.9725 18.7015 17.3284L19.194 12.9575C19.2985 12.0303 20.0303 11.2985 20.9575 11.194L25.3284 10.7015C25.9725 10.6289 26.5414 10.2488 26.8549 9.68152L28.9826 5.83178C29.434 5.01511 30.3901 4.61907 31.2867 4.87739L35.5134 6.09506C36.1362 6.27448 36.8073 6.14098 37.3141 5.73689L40.753 2.99442Z",
    fill: "url(#paint0_linear_6211_10269)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6211_10269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 59C55.8072 59 67.0001 47.8071 67.0001 34C67.0001 20.1929 55.8072 9 42 9C28.1929 9 17 20.1929 17 34C17 47.8071 28.1929 59 42 59Z",
    fill: "url(#paint1_linear_6211_10269)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M42 56C54.1503 56 64.0001 46.1503 64.0001 34C64.0001 21.8497 54.1503 12 42 12C29.8498 12 20 21.8497 20 34C20 46.1503 29.8498 56 42 56Z",
    fill: "url(#paint2_radial_6211_10269)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.0001 33.9261C63.0001 34.7868 62.9508 35.6474 62.8524 36.4835C62.7539 37.4179 62.5569 38.3523 62.3354 39.2376C62.2369 39.631 62.1384 39.9999 62.0153 40.3933C61.7937 41.0818 61.5476 41.7704 61.2521 42.4343C60.612 43.8851 59.8242 45.2375 58.8887 46.4916C58.1009 47.549 57.2146 48.5326 56.2299 49.4424C52.5124 52.885 47.5394 54.9752 42.074 54.9998C36.6086 55.0244 31.6109 52.9588 27.8689 49.5408C26.9087 48.6556 26.0225 47.6966 25.2346 46.6638C23.7575 44.7212 22.625 42.5081 21.9111 40.1474C21.5664 39.0409 21.3202 37.8851 21.1725 36.7048C21.0741 35.8442 21.0002 34.9835 21.0002 34.1229C20.951 22.4672 30.3061 13.0492 41.9263 13C53.5218 12.9755 62.9508 22.3197 63.0001 33.9261Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 55C53.598 55 63 45.598 63 34C63 22.402 53.598 13 42 13C30.402 13 21 22.402 21 34C21 45.598 30.402 55 42 55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 55C53.598 55 63 45.598 63 34C63 22.402 53.598 13 42 13C30.402 13 21 22.402 21 34C21 45.598 30.402 55 42 55Z",
    fill: "url(#paint3_linear_6211_10269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3594 28.3984C37.3594 28.1797 37.401 27.974 37.4844 27.7812C37.5677 27.5833 37.6823 27.4141 37.8281 27.2734C37.974 27.1276 38.1432 27.013 38.3359 26.9297C38.5339 26.8411 38.7422 26.7969 38.9609 26.7969H45.0391C45.2578 26.7969 45.4635 26.8411 45.6562 26.9297C45.8542 27.013 46.026 27.1276 46.1719 27.2734C46.3177 27.4141 46.4323 27.5833 46.5156 27.7812C46.599 27.974 46.6406 28.1797 46.6406 28.3984V29.8438H45.0391V28.3984H38.9609V36.3984H45.0391V33.6797H42V32.0781H46.6406V36.3984C46.6406 36.6172 46.599 36.8255 46.5156 37.0234C46.4323 37.2161 46.3177 37.3854 46.1719 37.5312C46.026 37.6771 45.8542 37.7917 45.6562 37.875C45.4635 37.9583 45.2578 38 45.0391 38H38.9609C38.7422 38 38.5339 37.9583 38.3359 37.875C38.1432 37.7917 37.974 37.6771 37.8281 37.5312C37.6823 37.3854 37.5677 37.2161 37.4844 37.0234C37.401 36.8255 37.3594 36.6172 37.3594 36.3984V28.3984Z",
    fill: "url(#paint4_linear_6211_10269)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6211_10269",
    x: 0,
    y: 0,
    width: 84,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.0196078 0 0 0 0 0.2 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6211_10269"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6211_10269",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6211_10269",
    x: 11,
    y: 6,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.0196078 0 0 0 0 0.2 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6211_10269"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6211_10269",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6211_10269",
    x1: 9.96529,
    y1: 33.9895,
    x2: 74.0138,
    y2: 33.9895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3123,
    stopColor: "#FDB836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7592,
    stopColor: "#FDC966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1DC83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6211_10269",
    x1: 16.9729,
    y1: 33.9918,
    x2: 67.0108,
    y2: 33.9918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3123,
    stopColor: "#FDB836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7592,
    stopColor: "#FDC966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1DC83"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_6211_10269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.989 33.9889) scale(21.9893 21.9893)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#571600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6211_10269",
    x1: 42,
    y1: 13,
    x2: 42,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6211_10269",
    x1: 35.493,
    y1: 33.9974,
    x2: 48.5028,
    y2: 33.9974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAA87D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3123,
    stopColor: "#B57B0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7592,
    stopColor: "#A08042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCAC66"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgegold);
export default __webpack_public_path__ + "static/media/badge gold.176f8ffd9d10004b7e61921e5d1f5747.svg";
export { ForwardRef as ReactComponent };